import React from "react";

import MainCarousel from "../../../Components/HomeCarousel/MainCarousel";
import ImageGallery from "../../../Components/ImageGallery";

function Home() {
  return (
    <div>
      <MainCarousel />
      <ImageGallery />
    </div>
  );
}

export default Home;
